<template>
  <b-tabs
    content-class="mt-0"
    class="file-manager"
    no-fade
    no-key-nav
  >
    <b-tab
      title="Dalet files"
      lazy
      @click="onTabChange('dalet')"
    >
      <dalet-file-manager :in-editor="inEditor" />
    </b-tab>
    <b-tab
      title="Mam files"
      lazy
      @click="onTabChange('mam')"
    >
      <mam-file-manager :in-editor="inEditor" />
    </b-tab>
  </b-tabs>
</template>

<script>
import {
  BTabs, BTab,
} from 'bootstrap-vue'
import MamFileManager from './components/MamFileManager.vue';
import DaletFileManager from './components/DaletFileManager.vue';

export default {
  components: {
    BTabs,
    BTab,
    MamFileManager,
    DaletFileManager,
  },
  props: {
    inEditor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabIndex: 0,
    }
  },
  methods: {
    onTabChange(e) {
      console.log('this.tabIndex', this.tabIndex);
    },
  },
}
</script>
<style lang="scss" >
.file-manager {
  .file-manager {
    .icon {
      margin-right: 5px;

      &:hover {
        cursor: pointer;
      }
    }

    .muted {
      color: gray;
      font-size: 80%;
    }

    .file-status-badge {
      width: 8px;
      height: 8px;
      display: inline-block;
      padding: 0;
      margin-right: 5px;
    }
  }
